module.exports = __webpack_public_path__ + "img/system.4603526e.png";